import { redirect } from "react-router-dom";
import domain from "../domain";

export async function action() {
  try {
    await fetch(`${domain}/ad/logout`, {
      method: "POST",
      credentials: "include",
    });
  } catch (err) {
    console.log("logout request failed", err);
  }

  localStorage.removeItem("id");
  localStorage.removeItem("role");
  localStorage.removeItem("token"); // clear any legacy JWT left from old clients

  sessionStorage.removeItem("mainData");
  sessionStorage.removeItem("subData");
  sessionStorage.removeItem("mainDataTimeRange");
  sessionStorage.removeItem("timeRange");
  sessionStorage.removeItem("mergedTagsData");
  sessionStorage.removeItem("branchesWithStoredData");
  sessionStorage.removeItem("attribution");

  return redirect("/login");
}
